import React from 'react';
import { Box, Typography } from '@mui/material';

interface PlacaBrasilProps {
  placa: string;
  size?: 'small' | 'medium';
  onClick?: () => void;
}

const normalizarPlaca = (placa: string) => placa.toUpperCase().replace(/[^A-Z0-9]/g, '');

const isMercosul = (p: string) => /^[A-Z]{3}\d[A-Z]\d{2}$/.test(p);
const isAntiga = (p: string) => /^[A-Z]{3}\d{4}$/.test(p);

const formatarTextoPlaca = (p: string) => {
  if (isMercosul(p)) return p;
  if (isAntiga(p)) return `${p.slice(0, 3)}-${p.slice(3)}`;
  return p;
};

const PlacaBrasil: React.FC<PlacaBrasilProps> = ({ placa, size = 'small', onClick }) => {
  const p = normalizarPlaca(placa);
  const texto = formatarTextoPlaca(p);
  const mercosul = isMercosul(p);

  const width = size === 'small' ? 108 : 140;
  const fontSize = size === 'small' ? 12 : 15;
  const faixaAltura = size === 'small' ? 14 : 18;

  if (mercosul) {
    return (
      <Box
        onClick={onClick}
        sx={{
          width,
          border: '2px solid #1a1a1a',
          borderRadius: '5px',
          overflow: 'hidden',
          bgcolor: '#f8f8f8',
          cursor: onClick ? 'pointer' : 'default',
          boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
          userSelect: 'none',
        }}
      >
        <Box
          sx={{
            height: faixaAltura,
            bgcolor: '#003399',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: 0.75,
          }}
        >
          <Box
            component="img"
            src={new URL('../../assets/countries/w20/br.png', import.meta.url).href}
            alt=""
            sx={{
              position: 'absolute',
              right: size === 'small' ? 4 : 6,
              width: size === 'small' ? 10 : 12,
              height: size === 'small' ? 7 : 8,
              borderRadius: '1px',
              objectFit: 'cover',
            }}
          />
          <Typography sx={{ color: '#fff', fontSize: size === 'small' ? 7 : 8, fontWeight: 700, lineHeight: 1 }}>
            BRASIL
          </Typography>
        </Box>
        <Box sx={{ py: size === 'small' ? 0.4 : 0.6, textAlign: 'center' }}>
          <Typography
            sx={{
              fontWeight: 800,
              fontSize,
              letterSpacing: 1.5,
              color: '#111',
              fontFamily: '"Arial Black", "Arial", sans-serif',
              lineHeight: 1.1,
            }}
          >
            {texto}
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      onClick={onClick}
      sx={{
        width,
        border: '2px solid #4a4a4a',
        borderRadius: '4px',
        bgcolor: 'linear-gradient(180deg, #e8e8e8 0%, #d0d0d0 100%)',
        background: 'linear-gradient(180deg, #ececec 0%, #c8c8c8 100%)',
        cursor: onClick ? 'pointer' : 'default',
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.8), 0 1px 2px rgba(0,0,0,0.15)',
        py: size === 'small' ? 0.6 : 0.9,
        textAlign: 'center',
        userSelect: 'none',
      }}
    >
      <Typography
        sx={{
          fontWeight: 800,
          fontSize,
          letterSpacing: 1.2,
          color: '#111',
          fontFamily: '"Arial Black", "Arial", sans-serif',
          lineHeight: 1.1,
        }}
      >
        {texto}
      </Typography>
    </Box>
  );
};

export default PlacaBrasil;
